import React from "react";
import { useNavigate } from "react-router-dom";

const PropertyCard = ({ data }) => {
  const navigate = useNavigate();
  return (
    <div className="property-card">
      <span className={`status-badge ${data.status.replace(" ", "-").toLowerCase()}`}>
        {data.status}
      </span>

      <img src={data.property_image_url} alt={data.title} className="property-img" />

      <h3 className="property-title">{data.property_name}</h3>
      <p className="property-location">{data.location}</p>

      <div className="details-row">
        <span>{data.no_of_beds} Beds</span>
        <span>{data.no_of_bathroom} Baths</span>
        <span>{data.plot_size} sq.ft.</span>
      </div>

      <div className="price-row">
        <h4>₹ {data.price}</h4>

        {data.status === "Sold" || data.status === "Ongoing" ? (
          <button className="sold-btn">Not Available</button>
        ) : (
          <button
            className="book-btn"
            onClick={() =>
              navigate("/properties/details", {
                state: {
                  propertyData: data
                }
              })
            }
          >
            Visit Now
          </button>

        )}
      </div>
    </div>
  );
};

export default PropertyCard;
